import React, { useState } from "react";
import "./rezervace-ubytovani-new.css";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";

const ACCESS_KEY = "aa0e01f6-1850-4c79-85f6-932a7bc5655d"; // Web3Forms – form "Ubytování", chodí na ubytovani@hospudkapodrablinu.cz

const RezervaceUbytovani: React.FC = () => {
  const [form, setForm] = useState({
    jmeno: "",
    prijmeni: "",
    email: "",
    telefon: "",
    pocet_hostu: "",
    termin1: "",
    termin2: "",
    poznamky: "",
    gdpr: false,
    botcheck: "" // honeypot
  });

  const [odeslano, setOdeslano] = useState(false);
  const [chyba, setChyba] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target as HTMLInputElement;
    const checked = (e.target as HTMLInputElement).checked;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setChyba("");

    if (form.botcheck) return; // honeypot

    if (
      !form.jmeno || !form.prijmeni || !form.email || !form.telefon ||
      !form.pocet_hostu || !form.termin1 || !form.termin2 || !form.gdpr
    ) {
      setChyba("Vyplňte prosím všechna povinná pole a potvrďte souhlas se zpracováním údajů.");
      return;
    }

    if (form.termin2 < form.termin1) {
      setChyba("Datum odjezdu musí být stejné nebo pozdější než datum příjezdu.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        access_key: ACCESS_KEY,
        subject: "Rezervace ubytování – webový formulář",
        from_name: "Hospůdka pod Rablinů – web",
        reply_to: form.email,
        email: form.email,
        jmeno: form.jmeno,
        prijmeni: form.prijmeni,
        telefon: form.telefon,
        pocet_hostu: form.pocet_hostu,
        datum_prijezdu: form.termin1,
        datum_odjezdu: form.termin2,
        poznamky: form.poznamky || "-",
        gdpr: form.gdpr ? "Souhlas udělen" : "Ne",
        botcheck: form.botcheck
      };

      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (data.success) {
        setOdeslano(true);
        setForm({
          jmeno: "",
          prijmeni: "",
          email: "",
          telefon: "",
          pocet_hostu: "",
          termin1: "",
          termin2: "",
          poznamky: "",
          gdpr: false,
          botcheck: ""
        });
      } else {
        setChyba(data.message || "Odeslání se nezdařilo. Zkuste to prosím později.");
      }
    } catch {
      setChyba("Odeslání se nezdařilo. Zkuste to prosím později.");
    } finally {
      setLoading(false);
    }
  };

  if (odeslano) {
    return (
      <div className="reservation-page reservation-page--accommodation">
        <Navbar />
        <main className="reservation-shell">
          <div className="form-ok">
            Děkujeme! Vaše nezávazná poptávka byla odeslána. Brzy se vám ozveme.
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="reservation-page reservation-page--accommodation">
      <Navbar />

      <main className="reservation-shell">
        <section className="reservation-hero">
          <div className="reservation-hero__copy">
            <p className="reservation-eyebrow">Nezávazná poptávka</p>
            <h1>Rezervace ubytování</h1>
            <p className="reservation-lead">
              Pošlete termín, počet hostů a pár detailů k pobytu. Ozveme se vám
              zpět s potvrzením dostupnosti a dalším postupem.
            </p>
          </div>
        </section>

        <div className="reservation-form-stage">
          <div className="kontakt-form-outer">
            <form className="kontakt-form" onSubmit={handleSubmit} autoComplete="off">
              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-jmeno">Jméno</label>
                <input id="ubytovani-jmeno" name="jmeno" type="text" placeholder="Např. Jana" value={form.jmeno} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-prijmeni">Příjmení</label>
                <input id="ubytovani-prijmeni" name="prijmeni" type="text" placeholder="Např. Nováková" value={form.prijmeni} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-email">E-mail</label>
                <input id="ubytovani-email" name="email" type="email" placeholder="vas@email.cz" value={form.email} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-telefon">Telefon</label>
                <input id="ubytovani-telefon" name="telefon" type="tel" placeholder="+420 123 456 789" value={form.telefon} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--full">
                <label htmlFor="ubytovani-pocet-hostu">Počet hostů</label>
                <input id="ubytovani-pocet-hostu" name="pocet_hostu" type="number" placeholder="Např. 4" value={form.pocet_hostu} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-termin1">Datum příjezdu</label>
                <input id="ubytovani-termin1" name="termin1" type="date" value={form.termin1} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="ubytovani-termin2">Datum odjezdu</label>
                <input id="ubytovani-termin2" name="termin2" type="date" value={form.termin2} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--full">
                <label htmlFor="ubytovani-poznamky">Poznámky</label>
                <textarea id="ubytovani-poznamky" name="poznamky" placeholder="Upřesněte požadavky, děti, domácí mazlíčky nebo jiné detaily." value={form.poznamky} onChange={handleChange} rows={4} />
              </div>

              <input
                type="text"
                name="botcheck"
                value={form.botcheck}
                onChange={handleChange}
                tabIndex={-1}
                autoComplete="off"
                style={{ display: "none" }}
              />

              <label className="form-gdpr field-group--full">
                <input type="checkbox" name="gdpr" checked={form.gdpr} onChange={handleChange} required />
                <span>Souhlasím se zpracováním osobních údajů a odesláním nezávazné poptávky.</span>
              </label>

              {chyba && <div className="form-error field-group--full">{chyba}</div>}

              <div className="form-actions field-group--full">
                <button type="submit" disabled={loading}>
                  {loading ? "Odesílám…" : "Odeslat nezávaznou poptávku"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RezervaceUbytovani;
